import { uid } from '../../../../lib/uid';

/**
 * Test data backing the Autogenerate button on the plantilla post form.
 *
 * Fills every required field so the primary action enables on the first try. Keep it in
 * lockstep with the form: a new required field must be added here in the same change, or
 * Autogenerate silently stops working.
 *
 * The two foreign keys — the catalog title and the unit — are NOT here. They are resolved
 * against the options the form has already loaded, because an id this module invented would
 * fail the server's "it must exist and be active" check, which reads as a bug in the form
 * rather than as bad sample data.
 */
export interface SamplePlantillaPost {
  /**
   * One to three item numbers. TYPED by the reader now (16 Oct 2026), and unique across every
   * item there has ever been — so each carries a suffix, or a second click would collide.
   * Obviously synthetic: never a real number off a real plantilla.
   */
  itemNumbers: string[];
}

/*
  No code: the plantilla id is {PositionCode}-{YY}{NNN} and the server assigns it inside the
  write, so there is nothing here to generate.
*/
export function samplePlantillaPost(): SamplePlantillaPost {
  return { itemNumbers: sampleItemNumbers(1 + Math.floor(Math.random() * 3)) };
}

/** `count` synthetic item numbers, unique to this click: `SAMPLE-1A2B3C-001`, …. */
export function sampleItemNumbers(count: number): string[] {
  const batch = uid().slice(0, 6).toUpperCase();

  return Array.from({ length: count }, (_, index) => `SAMPLE-${batch}-${String(index + 1).padStart(3, '0')}`);
}
